import React from 'react';
import { useDroppable } from '@dnd-kit/core';
import { ExclamationCircleOutlined, ArrowUpOutlined, ArrowDownOutlined } from '@ant-design/icons';

const DroppableOrgNode = ({ 
  org, 
  children, 
  isDraggedOver, 
  dragValidation 
}) => {
  const { isOver, setNodeRef } = useDroppable({
    id: org.id,
    data: {
      type: 'org',
      org,
    },
  });

  // Determine drop zone styling based on validation
  const getDropZoneStyle = () => {
    if (!isOver || !dragValidation) {
      return {};
    }

    if (!dragValidation.isValid) {
      return {
        border: '2px dashed #ff4d4f',
        backgroundColor: 'rgba(255, 77, 79, 0.1)',
      };
    }

    // Valid drop - show green styling
    return {
      border: '2px dashed #52c41a',
      backgroundColor: 'rgba(82, 196, 26, 0.1)',
    };
  };

  // Get feedback message for drop zone
  const getDropFeedback = () => {
    if (!isOver || !dragValidation) {
      return null;
    }

    if (!dragValidation.isValid) {
      return (
        <div style={{
          position: 'absolute',
          top: '-30px',
          left: '0',
          right: '0',
          background: '#ff4d4f',
          color: '#fff',
          padding: '4px 8px',
          borderRadius: '4px',
          fontSize: '12px',
          zIndex: 1000,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
        }}>
          <ExclamationCircleOutlined style={{ marginRight: '4px' }} />
          {dragValidation.reason}
        </div>
      );
    }

    // Valid drop - show simple move message
    return (
      <div style={{
        position: 'absolute',
        top: '-30px',
        left: '0',
        right: '0',
        background: '#52c41a',
        color: '#fff',
        padding: '4px 8px',
        borderRadius: '4px',
        fontSize: '12px',
        zIndex: 1000,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
      }}>
        Move under: <strong style={{ marginLeft: '4px' }}>{org.name}</strong>
      </div>
    );
  };

  const baseStyle = {
    position: 'relative',
    borderRadius: '6px',
    transition: 'all 0.2s ease',
  };

  const dropStyle = getDropZoneStyle();
  const combinedStyle = { ...baseStyle, ...dropStyle };

  return (
    <div ref={setNodeRef} style={combinedStyle} className="droppable-org-node">
      {getDropFeedback()}
      {children}
    </div>
  );
};

export default DroppableOrgNode;
